import { defineComponent as _defineComponent } from 'vue'
import { menu, socials } from "../../utils/menu";
import IconSocialsInstagram from "@/components/icons/base/IconSocialsInstagram.vue";
import IconSocialsFacebook from "@/components/icons/base/IconSocialsFacebook.vue";
import IconSocialsLinkedin from "@/components/icons/base/IconSocialsLinkedin.vue";
import IconSocialsTwitter from "@/components/icons/base/IconSocialsTwitter.vue";
import IconLogoImage from "@/components/icons/base/IconLogoImage.vue";
import IconLogoText from "@/components/icons/base/IconLogoText.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MainFooter',
  setup(__props) {


return { __sfc: true,menu, socials, IconSocialsInstagram, IconSocialsFacebook, IconSocialsLinkedin, IconSocialsTwitter, IconLogoImage, IconLogoText }
}

})